/**
 * Voice Management Navigation
 *
 * Shared navigation component for voice management pages
 */

import { NavLink } from 'react-router-dom';

export function VoiceNavigation() {
  const navItems = [
    { name: 'Voices', path: '/voices' },
    { name: 'Providers', path: '/voice-providers' },
    { name: 'Test Voice', path: '/voice-test' },
  ];

  return (
    <div className="mb-6 border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium transition-colors ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`
            }
          >
            {item.name}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
